import { FC } from "react";
import styled from "styled-components";

import Image from "@/components/Image";
import { hexToRgba } from "@/utils/theme";

const ThumbOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => hexToRgba(theme.colors.black, 0.5)};
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity ease-out 0.2s;
  cursor: pointer;
`;

const ThumbHolder = styled.div`
  width: 162px;
  height: 84px;
  position: relative;
  &:hover {
    ${ThumbOverlay} {
      opacity: 1;
    }
  }
`;

const EnlargeButton = styled.button`
  background-color: ${({ theme }) => hexToRgba(theme.colors.white, 0.5)};
  border-radius: 4px;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity ease-out 0.2s;
  &:hover,
  &:active {
    opacity: 0.8;
  }
  svg {
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const Thumbnail = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: ${({ theme }) => theme.colors.grayscaleLight};
`;

interface Props {
  thumbnail?: string;
  setIsLightBoxVisible: React.Dispatch<React.SetStateAction<boolean>>;
}

const PostThumbnail: FC<Props> = ({ thumbnail, setIsLightBoxVisible }) => {
  return (
    <ThumbHolder onClick={(e) => e.stopPropagation}>
      <Thumbnail src={thumbnail} />
      {!!thumbnail && (
        <>
          <ThumbOverlay
            onClick={(e) => {
              e.stopPropagation();
              setIsLightBoxVisible(true);
            }}
          >
            <EnlargeButton>
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_6296_142904)">
                  <path
                    d="M7.85742 1.35742H10.6431V4.14314"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7.39258 4.60742L10.6426 1.35742"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M4.14314 10.6431H1.35742V7.85742"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M4.60742 7.39258L1.35742 10.6426"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_6296_142904">
                    <rect width="12" height="12" fill="currentColor" />
                  </clipPath>
                </defs>
              </svg>
            </EnlargeButton>
          </ThumbOverlay>
        </>
      )}
    </ThumbHolder>
  );
};

export default PostThumbnail;
